var _g, _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightSelectedNumbers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 16c30.253 0 30 13.431 30 30 0 16.569.457 30-30 30S16 62.569 16 46c0-16.569-.255-30 30-30z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.653 34.273a4.48 4.48 0 0 0-2.917.982l-1.5 4.629a39.602 39.602 0 0 0 1.885 3.808 22.95 22.95 0 0 0 3.042 1.061c.091-.144-6.36-5.285-.51-10.48zM41.505 46.257a11.994 11.994 0 0 0-4.806 5.389c-1.636 3.709-1.256 5.393-1.256 5.393s-1.734-.805-1.847-.842a7.933 7.933 0 0 1-.336-3.116c.256-.444 4.792-6.008 5.052-6.082.26-.074 3.193-.742 3.193-.742z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.129 45.65c-5.948 0-10.77 4.815-10.77 10.754h17.538c2.21 0 4.071-1.852 3.267-3.909a10.773 10.773 0 0 0-10.035-6.845z",
    fill: "#DCF4E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.806 54.143c1.592-5.185 6.426-8.955 12.14-8.955s10.547 3.77 12.14 8.955c.238.777.026 1.492-.471 2.038-.51.559-1.32.934-2.223.934H34.5c-.903 0-1.714-.375-2.223-.934-.498-.546-.71-1.261-.471-2.038z",
    stroke: "url(#b)",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.75 51.54c0 3.705-3.008 6.71-6.72 6.71-3.712 0-6.72-3.005-6.72-6.71 0-3.704 3.008-6.709 6.72-6.709 3.712 0 6.72 3.005 6.72 6.71z",
    fill: "#fff",
    stroke: "#00A6CE",
    strokeWidth: 1.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.062,
    cy: 39.465,
    rx: 4.98,
    ry: 4.973,
    fill: "#DCF4E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.04 39.465a5.72 5.72 0 0 1-5.725 5.715 5.72 5.72 0 0 1-5.724-5.715 5.72 5.72 0 0 1 5.724-5.715 5.72 5.72 0 0 1 5.724 5.715z",
    stroke: "url(#c)",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m51.042 51.371 2.646 2.159 3.33-3.979",
    stroke: "#00A6CE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 57.756,
    y1: 41.8,
    x2: 36.033,
    y2: 43.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 51.965,
    y1: 30.46,
    x2: 41.439,
    y2: 30.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1626_12125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1626_12125",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSelectedNumbers);
export default __webpack_public_path__ + "static/media/lightSelectedNumbers.e6f03b854b5fdc7d210a57189b404a07.svg";
export { ForwardRef as ReactComponent };